<template>
<vx-card>
    <div class="vx-row" v-if="usuario.id_group == 1 || usuario.id_group == 10">
        <div class="w-full p-2 bg-gray-400 text-center">
            <p class="text-warning font-semibold">Seleccione la institución</p>
            <v-select :options="instituciones" @input="changehandleUpdate()" :reduce="instituciones => instituciones" label="nombreInstitucion" class="w-full mt-2" v-model="institucion_General" />
        </div>
    </div>
    <!-- {{ institucion_General }} -->
    <div class="vx-row mt-2">
        <div class="vx-col md:w-1/4 w-full mb-3 flex sidebar-left">
            <div v-if="usuario.id_group == 1 || usuario.id_group == 6 || usuario.id_group == 10" class="text-center p-2 tituloMenu" @click="CrearComunicacion()">Crear comunicación</div>
            <!-- <p class="subtema">Comunicaciones</p> -->
            <div class="flex mt-5 font-hairline" style="justify-content: space-around;">
                <div style="width: 60%;">
                    <i class="fa-solid fa-envelope" style="font-size: 11px;"></i> <span class="ml-3 c_opciones">Enviadas</span>
                </div>
                <div style="width: 40%;" class="flex justify-end">
                    <span style="background-color: #3EA0EA;" @click="turno = 1;filtroTipo();" class="c_cantidad">{{ sumaEnviadas }}</span>
                </div>
            </div>
            <div class="flex mt-3 font-hairline" style="justify-content: space-around;">
                <div style="width: 60%;">
                    <i class="fa-regular fa-envelope" style="font-size: 11px;"></i> <span class="ml-3 c_opciones">Por responderme</span>
                </div>
                <div style="width: 40%;" class="flex justify-end">
                    <span @click="turno = 2;filtroTipo();" style="background-color: #F06060;max-height: 18px;" class="c_cantidad">{{ sumaPorResponder }}</span>
                </div>
            </div>
            <div class="flex mt-3 font-hairline" style="justify-content: space-around;">
                <div style="width: 60%;">
                    <i class="fa-solid fa-sun" style="font-size: 11px;"></i> <span class="ml-3 c_opciones">Sin Respuesta</span>
                </div>
                <div style="width: 40%;" class="flex justify-end">
                    <span @click="turno = 3;filtroTipo();" style="background-color: #E8C65A;max-height: 18px;" class="c_cantidad">{{ sumaSinRespuesta }}</span>
                </div>
            </div>
            <div class="flex mt-3 font-hairline" style="justify-content: space-around;">
                <div style="width: 60%;">
                    <i class="fa-regular fa-file" style="font-size: 11px;"></i> <span class="ml-3 c_opciones"> Finalizadas</span>
                </div>
                <div style="width: 40%;" class="flex justify-end">
                    <span @click="turno = 4;filtroTipo();" style="background-color: #35D392;max-height: 18px;" class="c_cantidad">{{ sumaFinalizadas }}</span>
                </div>
            </div>
            <!-- <p class="subtema">Agrupado por:</p>
                <div class="flex mt-5 font-hairline" style="justify-content: space-around;">
                    <div style="width: 50%;">
                        <span class="ml-3 c_opciones"> Tipo</span>
                    </div>
                    <div style="width: 50%;" class="flex justify-end" >
                        <span @click="btnTipo=!btnTipo;changeMenu(btnTipo,1)"><i class="fa-solid fa-chevron-down cursor-pointer"></i></span>
                    </div>
                </div> -->
            <!-- <div class="hideTipo" id="smenu1">
                    <template v-if="btnTipo == true">
                        <div style="width: 100%;">
                            <i class="fa-solid fa-circle ml-5 mt-5" style="color: #35D392;font-size: 10px;"></i> <span @click="turno=5;filtroTipo();" class="ml-4 subtitle">Comunicación General ({{ sumaComunicacionGeneral }})</span>
                        </div>
                        <div style="width: 100%;" v-if="usuario.id_group != 4">
                            <i class="fa-solid fa-circle ml-5 mt-5" style="color: #35D392;font-size: 10px;"></i> <span @click="turno=6;filtroTipo();" class="ml-4 subtitle">Comunicación al Docente ({{ sumaComunicacionDocente }})</span>
                        </div>
                        <div style="width: 100%;">
                            <i class="fa-solid fa-circle ml-5 mt-5" style="color: #35D392;font-size: 10px;"></i> <span @click="turno=7;filtroTipo();" class="ml-4 subtitle">Comunicación al Estudiante ({{ sumaComunicacionEstudiante }})</span>
                        </div>
                    </template>
                </div> -->
            <!-- <div v-if="usuario.id_group == 1 || usuario.id_group == 4" class="flex mt-5 font-hairline" style="justify-content: space-around;">
                    <div style="width: 50%;">
                        <span class="ml-3 c_opciones"> Profesores</span>
                    </div>
                    <div style="width: 50%;" class="flex justify-end" >
                        <span @click="btnProfesores=!btnProfesores;changeMenu(btnProfesores,2)"><i class="fa-solid fa-chevron-down cursor-pointer"></i></span>
                    </div>
                </div> -->
            <!-- <div v-if="usuario.id_group == 1" class="hideTipo" id="smenu2">
                    <template v-if="btnProfesores == true">
                        <div style="width: 100%;" v-for="(tr,key) in arregloMensajesDocentes" :key="key">
                            <i class="fa-solid fa-circle ml-5 mt-5" style="color: #E8C65A;font-size: 10px;"></i> <span @click="receptor_id = tr.receptor_id;turno = 8;filtroTipo();" class="ml-4 subtitle">{{ tr.docente.toUpperCase() }} ({{ tr.docenteContador }})</span>
                        </div>
                    </template>
                </div>
                <div v-if="usuario.id_group == 4" class="hideTipo" id="smenu2">
                    <template v-if="btnProfesores == true">
                        <div style="width: 100%;" v-for="(tr,key) in arregloMensajesDocentes" :key="key">
                            <i class="fa-solid fa-circle ml-5 mt-5" style="color: #E8C65A;font-size: 10px;"></i> <span @click="receptor_id = tr.receptor_id;turno = 9;filtroTipo();" class="ml-4 subtitle">{{ tr.docente.toUpperCase() }} ({{ tr.docenteContador }})</span>
                        </div>
                    </template>
                </div> -->
        </div>
        <div class="vx-col md:w-3/4 w-full flex">
            <ListadoComunicadosVue :institucion_General="institucion_General" :arregloComunicaciones="tmparregloComunicaciones" :totalTable="totalTable" v-if="menu == 0" @changeComunicados="changehandleUpdate" @changeOpen="changehandleOpenComunicado" class="fade-in" />
            <CrearComunicadoVue @changeUpdate="changehandleUpdate" :institucion_General="institucion_General" v-if="menu == 1" class="fade-in" />
            <VerComunicadoVue @changeUpdate="changehandleUpdate" :institucion_General="institucion_General" :ComunicadoEnviar="ComunicadoEnviar" v-if="menu == 2" class="fade-in" />
        </div>
    </div>
</vx-card>
</template>

<script>
import $ from 'jquery'
import io from 'socket.io-client';
import vSelect from 'vue-select'
import ListadoComunicadosVue from './ListadoComunicados.vue';
import CrearComunicadoVue from './CrearComunicado.vue';
import VerComunicadoVue from './VerComunicado.vue'
export default {
    data() {
        return {
            btnTipo: false,
            btnProfesores: false,
            btnMaterias: false,
            menu: 0,
            instituciones: [],
            usuario: [],
            arregloComunicaciones: [],
            tmparregloComunicaciones: [],
            arregloMensajesDocentes: [],
            institucion_General: '',
            ComunicadoEnviar: {},
            //v listados
            totalTable: 0,
            receptor_id: 0,
            turno: 0,
            // socket:io(process.env.socket) 
            retornar: 0,
        }
    },
    created() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0]
    },
    mounted() {
        let me = this;
        me.getInstituciones()
        this.$socket.on('enviar', (data) => {
            if (data.tipo == 'comunicacion') {
                //si es tipo comunicacion 2 => para un docente especifico
                if (data.tipo_comunicacion == 2) {
                    //si envia el docente al administrador
                    if (data.grupoEmisor == 1) {
                        if (me.usuario.id_group == 1) {
                            me.sendMensaje()
                            return
                        }
                        return
                    }
                    //solo actualizo al docente especifico
                    if (data.receptor == me.usuario.idusuario) {
                        me.sendMensaje()
                        return
                    }
                }
                //comunicacion a estudiante
                if (data.tipo_comunicacion == 3) {
                    //si  el mensaje es para el admin
                    if (data.grupoEmisor == 1) {
                        if (me.usuario.id_group == 1) {
                            me.sendMensaje()
                            return
                        }
                        return
                    }
                    //si la comunicacion es de estudiante o estudiante
                    if (data.receptor == me.usuario.idusuario) {
                        me.sendMensaje()
                        return
                    }
                }
            }
        });
    },
    components: {
        ListadoComunicadosVue,
        CrearComunicadoVue,
        VerComunicadoVue,
        vSelect,
    },
    computed: {
        sumaEnviadas() {
            let me = this;
            let filtro = me.arregloComunicaciones;
            let resultado = filtro.length
            return resultado
        },
        sumaPorResponder() {
            let me = this;
            let filtro = me.arregloComunicaciones.filter(p => p.estadoMessage == '1' && p.estado == '1');
            let resultado = filtro.length
            return resultado
        },
        sumaSinRespuesta() {
            let me = this;
            let filtro = me.arregloComunicaciones.filter(p => p.estadoMessage == '2' && p.estado == '1');
            let resultado = filtro.length
            return resultado
        },
        sumaFinalizadas() {
            let me = this;
            let filtro = me.arregloComunicaciones.filter(p => p.estado == '0');
            let resultado = filtro.length
            return resultado
        },
        sumaComunicacionGeneral() {
            let me = this;
            let filtro = me.arregloComunicaciones.filter(p => p.tipo_comunicacion == '1');
            let resultado = filtro.length
            return resultado
        },
        sumaComunicacionDocente() {
            let me = this;
            let filtro = me.arregloComunicaciones.filter(p => p.tipo_comunicacion == '2');
            let resultado = filtro.length
            return resultado
        },
        sumaComunicacionEstudiante() {
            let me = this;
            let filtro = me.arregloComunicaciones.filter(p => p.tipo_comunicacion == '3');
            let resultado = filtro.length
            return resultado
        },
    },
    methods: {
        CrearComunicacion() {
            let me = this;
            if (me.institucion_General == "" || me.institucion_General == null || me.institucion_General == undefined) {
                me.$vs.notify({
                    text: 'Seleccione una institución por favor',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                return
            }
            me.menu = 1
        },
        sendMensaje() {
            let me = this;
            me.getComunicados()
            me.$vs.notify({
                text: 'Te llego un mensaje de comunicación',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
            })
        },
        changehandleUpdate(e) {
            let me = this;
            me.getComunicados()
            me.menu = 0
        },
        changehandleOpenComunicado(e) {
            let me = this
            me.ComunicadoEnviar = e.comunicado
            me.menu = 2
        },
        getInstituciones() {
            let me = this;
            var url = ""
            if (me.usuario.id_group == 10) {
                url = this.$server_url + 'verInstitucionDirector?idusuario=' + me.usuario.idusuario
            }
            if (me.usuario.id_group == 1) {
                url = this.$server_url + 'listaInsitucionActivas'
            }
            if (me.usuario.id_group == 6) {
                url = ""
            }
            if (url != "") {
                this.$http.get(url)
                    .then(function (res) {
                        // console.log(res.data)
                        me.instituciones = res.data;
                        if (res.data.message) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-user'
                            })
                        }
                        //incrustar la institucion del administrador por defecto
                        let datos = me.instituciones.filter(p => p.idInstitucion == me.usuario.institucion_idInstitucion)
                        if (datos.length > 0) {
                            me.institucion_General = datos[0]
                            me.getComunicados()
                        }
                    })
                    .catch(function (error) {
                        console.log(error + ' error');
                    })
            } else {
                me.institucion_General = {
                    "idinstitucion": me.usuario.institucion_idInstitucion,
                    "nombreInstitucion": (localStorage.getItem("nombreInstitucion")),
                    "periodo_id": (localStorage.getItem("periodo_id"))
                }
                me.getComunicados()
            }
        },
        changeMenu(boleano, id) {
            const tipo = document.querySelector("#smenu" + id);
            if (boleano) {
                tipo.classList.remove("hideTipo");
                tipo.classList.toggle("showTipo");
            } else {
                tipo.classList.remove("showTipo");
                tipo.classList.toggle("hideTipo");
            }
        },
        //COMUNICADOS
        getComunicados() {
            let me = this;
            me.arregloComunicaciones = []
            me.tmparregloComunicaciones = []
            me.arregloMensajesDocentes = []
            //si es administrador sera cero / otros usuarios sera el idusuario
            let user = 0
            if (me.institucion_General == null || me.institucion_General == "" || me.institucion_General == undefined) {
                me.$vs.notify({
                    text: "Seleccione una institución por favor",
                    color: 'primary',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                return
            }
            if (me.usuario.id_group != 1) user = me.usuario.idusuario
            me.$vs.loading();
            this.$http.get(this.$server_url + 'comunicaciones?institucion_id=' + me.institucion_General.idinstitucion + '&periodo_id=' + me.institucion_General.periodo_id + '&user=' + user)
                .then(function (res) {
                    me.$vs.loading.close()
                    let datos = res.data.query
                    //Adminitrador
                    //que los comunicados sean solo realizados por el administrador
                    if (me.usuario.id_group == 1) {
                        let filtrar = datos.filter(p => p.id_group == 1)
                        me.arregloComunicaciones = filtrar
                        me.tmparregloComunicaciones = filtrar
                        //quitar arrays duplicados
                        let datos2 = res.data.docentes
                        let hash = {};
                        datos2 = datos2.filter(o => hash[o.docente] ? false : hash[o.docente] = true);
                        me.arregloMensajesDocentes = datos2
                    }
                    //docente
                    //que el tipo de comunicacion sea docente y especicamente al docente 
                    //o los comunicacados que el haya creado 
                    if (me.usuario.id_group == 6 || me.usuario.id_group == 10) {
                        let filtrar = datos.filter(p => (p.tipo_comunicacion == 2 && p.receptor_id == me.usuario.idusuario) || (p.user_created == me.usuario.idusuario))
                        me.arregloComunicaciones = filtrar
                        me.tmparregloComunicaciones = filtrar
                    }
                    //estudiante
                    //que el tipo de comunicacion sea al estudiante 
                    //que la comunicacion general sea igual al curso que esta cursando el estudiante
                    if (me.usuario.id_group == 4) {
                        // let filtrar = datos.filter(p => (p.tipo_comunicacion == 3 && p.receptor_id == me.usuario.idusuario) || (p.tipo_comunicacion == 1 && p.receptor_id == localStorage.codigo_curso))
                        // me.arregloComunicaciones    = filtrar
                        // me.tmparregloComunicaciones = filtrar
                        // //obtener los comunicados de los profesores
                        // let datosProfesores         = filtrar.filter(p => p.id_group == 6)
                        // me.setTeachers(datosProfesores)
                        // let filtrar = datos.filter(p => (p.tipo_comunicacion == 3 && p.receptor_id == me.usuario.idusuario) || (p.tipo_comunicacion == 1 && p.receptor_id == localStorage.codigo_curso))
                        let filtrar = datos.filter(p => (p.tipo_comunicacion == 3 && p.receptor_id == me.usuario.idusuario) || (p.tipo_comunicacion == 1))
                        var preValor = []
                        filtrar.forEach(element => {
                            me.retornar = 0
                            let gettipo_comunicacion = element.tipo_comunicacion
                            let codigo = element.receptor_id
                            if (gettipo_comunicacion == 1) {
                                me.getCursoXEstudiante(codigo)
                                setTimeout(() => {
                                    if (me.retornar == 1) {
                                        preValor.push(element)
                                    }
                                }, 1000)

                            } else {
                                preValor.push(element)
                            }
                        });
                        me.arregloComunicaciones = preValor
                        me.tmparregloComunicaciones = preValor
                    }
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close()
                })
        },
        getCursoXEstudiante(codigo) {
            let me = this
            this.$http.get(this.$server_url + 'getCursoXEstudiante/' + codigo + '/' + me.usuario.idusuario)
                .then(function (res) {
                    me.retornar = res.data
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        setTeachers(tr) {
            let me = this;
            let valores = []
            let p = new Promise(function (resolve, reject) {
                if (tr.length) {
                    resolve(tr)
                } else {
                    reject('No hay comunicados de profesores')
                }
            });
            p.then((res) => {
                let datos = res
                datos.forEach(element => {
                    var cal = new Object();
                    cal.docente = element.emisor
                    cal.receptor_id = element.user_created
                    valores.push(cal)
                });
                //obtener contador por docente
                let reducer = function (acc, valores) {
                    acc[valores.docente] = (acc[valores.docente] || 0) + 1;
                    return acc;
                }
                let filtro = valores.reduce(reducer, [])
                //setear valores
                const result = valores.map((obj) => {
                    obj["docenteContador"] = filtro[obj.docente];
                    return obj;
                });
                //quitar duplicados
                let hash = {};
                let resultado = result.filter(o => hash[o.docente] ? false : hash[o.docente] = true);
                me.arregloMensajesDocentes = resultado
            }).catch((e) => {
                console.log(e)
            })
        },
        filtroTipo() {
            let me = this;
            me.menu = 0
            let datos = me.arregloComunicaciones
            //para ver los enviados
            if (me.turno == 1) {
                let filtro = me.arregloComunicaciones
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver los por responder
            if (me.turno == 2) {
                let filtro = datos.filter(p => p.estadoMessage == '1' && p.estado == '1');
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver los sin respuesta(que no he respondido)
            if (me.turno == 3) {
                let filtro = datos.filter(p => p.estadoMessage == '2' && p.estado == '1');
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver los por finalizar
            if (me.turno == 4) {
                let filtro = datos.filter(p => p.estado == 0)
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver la comunicacion general
            if (me.turno == 5) {
                let filtro = datos.filter(p => p.tipo_comunicacion == 1)
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver la comunicacion al docente
            if (me.turno == 6) {
                let filtro = datos.filter(p => p.tipo_comunicacion == 2)
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver la comunicacion al estudiante
            if (me.turno == 7) {
                let filtro = datos.filter(p => p.tipo_comunicacion == 3)
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver la comunicacion por profesor
            if (me.turno == 8) {
                let filtro = datos.filter(p => (p.tipo_comunicacion == 2) && (p.receptor_id == me.receptor_id))
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver la comunicacion por profesor desde el estudiante
            if (me.turno == 9) {
                let filtro = datos.filter(p => (p.user_created == me.receptor_id))
                me.tmparregloComunicaciones = filtro
                return
            }
            //para ver todos los codigos
            else {
                me.tmparregloComunicaciones = me.arregloComunicaciones
            }
        },
        //FIN METODOS COMUNICADOS
    }
}
</script>

<style lang="scss" scoped>
// :root {
//     --border: #DFE6EC;
//     --fondo: #EBF3F8;
//     --titulo: #22262D;
//     --subtitulo: #3E4448;
//     --texto: #5C5E62;
//     --detalles: #939699;
//     --violet: #8743FF;
//     --celeste: #1EB2FF;
//     --azul: #284DB4;
//     --colorazul: #3EA0EA;
//     --colorrojo: #F06060;
//     --coloramarillo: #E8C65A;
//     --colorverde: #35D392;
// }
.tituloMenu {
    margin-top: 25px;
    cursor: pointer;
    transition: 1s ease;
    background: #284DB4;
    color: white;
    font-weight: 400;
    border-radius: 5px;
    margin-top: 20px;
}

.subtema {
    font-weight: 600;
    margin-top: 25px;
}

.subtitle {
    font-size: 10px;
    cursor: pointer;
}

.tituloMenu:hover {
    background-color: #1EB2FF;
}

.fa-tag {
    font-size: 10px;
    margin-left: 5px;
}

.tag {
    font-size: 10px;
    margin-left: 10px;
    cursor: pointer;
    border: 1px solid #f2f2f2;
    padding: 5px;
    margin-top: 4px;
}

.c_opciones {
    font-size: 11px;
    font-weight: 350;
}

.c_cantidad {
    color: white;
    font-size: 9px;
    border-radius: 5px;
    min-width: 25%;
    text-align: center;
    padding-top: 4px;
    cursor: pointer;
}

//SHOW / SHOW
.showTipo {
    display: flex;
    flex-wrap: wrap;
    transition: 1s ease all;
    opacity: 1;
    transform: translateY(0%);
}

.hideTipo {
    opacity: 0;
    position: relative;
    transition: 1s ease all;
    transform: translateY(-30%);
}

//fin hide/show
.fade-in {
    opacity: 1;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.5s;
    padding: 10px;
    border: 1px solid #f2f2f2;
    max-height: 90%;
    margin-top: -1px !important;
}

@keyframes fadeInOpacity {
    0% {
        transform: translateX(30%);
        opacity: 0;
    }

    50% {
        transform: translateX(10%);
        opacity: 0.5;
    }

    100% {
        opacity: 1;
        transform: translateX(0%);
    }
}

.sidebar-left {
    flex-direction: column;
    border: 1px solid #fff;
    height: 800px;
}

/*RESPONSIVE*/
@media (max-width: 540px) {
    .sidebar-left {
        height: 100%;
    }
}

@media (max-width: 414px) {
    .sidebar-left {
        height: 100%;
    }
}

@media (max-width: 375px) {
    .sidebar-left {
        height: 100%;
    }
}
</style>
